export default {
	role: {
		buyerAgent: 'Buyer Agent',
		escrowAgent: 'Escrow Agent',
		loanOfficer: 'Loan Officer',
		loanOfficerAssistant: 'Loan Officer Assistant',
		loanProcessor: 'Loan Processor',
		sellerAgent: 'Seller Agent',
		settlementAgent: 'Settlement Agent',
		supportingLoanOfficer: 'Supporting Loan Officer',
		titleInsuranceAgent: 'Title Insurance Agent',
	},
	global: {
		yes: 'Yes',
		no: 'No',
		email: 'Email',
		password: 'Password',
		account: 'Account',
		phone_number: 'Phone Number',
		go_back: 'Go back',
		send: 'Send',
		resend: 'Resend',
		view: 'View',
		delete: 'Delete',
		created: 'Created',
		status: 'Status',
		reason: 'Reason',
		type: 'Type',
		level: 'Level',
		message: 'Message',
		details: 'Details',
		username: 'Username',
		retry: 'Retry',
		data: 'Data',
		save: 'Save',
		submit: 'Submit',
		verify: 'Verify',
		reverify: 'Reverify',
		upload: 'Upload',
		answer: 'Answer',
		close: 'Close',
		cancel: 'Cancel',
		publish: 'Publish',
		unpublish: 'Unpublish',
		workflow: 'Workflow',
		continue: 'Continue',
		name: 'Name',
		role: 'Role',
		invite: 'Invite',
		pending: 'Pending',
		mobile: 'Mobile',
		office: 'Office',
		home: 'Home',
		people: 'People',
		add: 'Add',
		added_on: 'Added On',
		settings: 'Settings',
		file_name: 'File Name',
		file_id: 'File ID',
		rename: 'Rename',
		edit: 'Edit',
		download: 'Download',
		untitled: 'Untitled',
		folder: 'Folder',
		search: 'Search',
		clear_search: 'Clear Search',
		sort_by: 'Sort By',
		sort_direction: 'Sort Direction',
		created_at: 'Created At',
		start_date: 'Start Date',
		end_date: 'End Date',
		error: 'There was an error fetching the data',
		accounts: 'Accounts',
		need_help: 'Need help?',
		log: {
			title: 'Logs',
			created_at: 'Created At',
			level: 'Level',
			message: 'Message',
		},
		bulk_select: 'Bulk Select',
		share: 'Share',
		refresh: 'Refresh',
		refreshing: 'Refreshing',
		select_branch: 'Select Branch',
		no_branches_found: 'No branches found',
		search_and_select_branch: 'Search and select a branch',
		assign_role: 'Assign Role',
	},
	auth: {
		sign_in: 'Sign In',
		dont_have_an_account: "Don't have an account?",
		check_inbox_for_invite_from_loan_officer:
			'Please check your email inbox for an invite from your Loan Officer',
		forgot_my_password: 'I Forgot My Password',
		existing_user_account_detected: 'Existing user account detected',
		sign_in_to_account: 'Sign in to your account',
		already_have_an_account: 'Already have an account?',
	},
	loans: {
		loan_id: 'Loan ID',
		not_assigned: 'Not Assigned',
		loan_users: 'Loan Users',
		loan_contacts: 'Loan Contacts',
		sync_with_los: 'Sync with LOS',
		los_id_is_required_to_perform_operation:
			'LOS loan ID is required to perform this operation',
		loan_synced_with_los: 'Loan successfully synced with LOS',
	},
	loan_queue: {
		loan_queue: 'Loan Queue',
		loan_queue_record: 'Loan Queue Record',
		type: {
			new_loan: 'New Loan',
			new_cob_loan: 'New Co-Borrower Loan',
			loan_update: 'Update Application',
			field_update: 'Field Update',
			document_upload: 'Document Upload',
			new_buckets: 'New Buckets',
		},
		job_id: 'Job ID',
	},
	loan_import: {
		loan_import: 'Loan Imports',
		imported_count: 'Imported Count',
		import_mode: 'Import Mode',
		attempt_count: 'Attempt Count',
		status: 'Status',
		status_filter: 'Status Filter',
		status_message: 'Status Message',
		created_at: 'Created At',
		date_range: 'Period',
		account_id: 'Account ID',
		new_loan_import: 'New Loan Import',
		edit_loan_import: 'Edit Loan Import',
		details: 'Loan Import Details',
		create_loan_import: 'Create Loan Import',
		update_loan_import: 'Update Loan Import',
		add_loan_import: 'Add Loan Import',
		remove_operation_not_implemented:
			'Remove operation not implemented yet',
		loading_problem: 'There was a problem loading the loan imports',
		invalid_date_range:
			'Invalid date range. Start date must be before or equal to end date, and end date cannot be in the future.',
		create_success: 'Loan Import successfully created',
		status_options: {
			show_all: 'Show All',
			waiting_process: 'Waiting Process',
			in_progress: 'In Progress',
			completed: 'Completed',
			failed: 'Failed',
			cancelled: 'Cancelled',
		},
		import_mode_options: {
			all: 'Full',
			new_only: 'New Only',
			update_only: 'Update Only',
		},
	},
	loan_log: {
		type: {
			loan: 'Loan',
			queue: 'Queue',
			pos_flag_changed: 'POS Flag Changed',
			verification: 'Verification',
		},
		level: {
			none: 'None',
			info: 'Info',
			warning: 'Warning',
			error: 'Error',
		},
	},
	users: {
		loan_officer: 'Loan Officer',
	},
	validation: {
		email: {
			required: 'Email is required',
			invalid: 'Email is invalid',
			unique_borrower:
				'Each borrower must have a unique email address',
		},
		password: {
			required: 'Password is required',
			minLength: 'Password must be at least {minLength} characters',
			create: 'Create password',
			confirm: 'Confirm password',
		},
		phone: {
			invalid: 'Phone number is invalid',
			required: 'Phone number is required',
		},
		name: {
			first_name_invalid: 'First name is invalid',
			last_name_invalid: 'Last name is invalid,',
			first_name_required: 'First name is required',
			last_name_required: 'Last name is required,',
		},
		file_name: {
			required: 'File name is required',
			no_periods: 'Do not use periods in the file name',
		},
		date: {
			select_valid_date: 'Please select a valid date',
			start_date_future: 'Start date cannot be in the future',
			end_date_future: 'End date cannot be in the future',
			end_date_before_start:
				'End date must be on or after start date',
			start_date_required: 'Start date is required',
			end_date_required: 'End date is required',
		},
	},
	errors: {
		general: 'There was an error processing the request',
		error_loading:
			'There was a problem retrieving the information requested',
		invalid_credentials: 'Invalid username and/or password',
		account_doesnt_have_access_to_env:
			'Your account does not have access to this environment',
		error_retrieving_auth: 'Error retrieving authentication info',
		account_already_exists:
			'An account with this email address already exists',
		unexpected_error: 'An unexpected error has occurred.',
		loan_calculator_permissions: `You don't have permission to update the required fields. Please contact your loan officer to update the loan.`,
		unable_to_connect:
			'Unable to connect to the server. Please check your internet connection and try again.',
		request_timeout:
			'The request took too long to complete. Please try again.',
		invalid_request:
			'Invalid request. Please check your input and try again.',
		session_expired: 'Your session has expired. Please log in again.',
		no_permission:
			'You do not have permission to perform this action.',
		resource_not_found: 'The requested resource was not found.',
		request_conflict:
			'There was a conflict with your request. Please refresh and try again.',
		invalid_input: 'Please check your input and try again.',
		too_many_requests:
			'Too many requests. Please wait a moment and try again.',
		request_issue:
			'There was an issue with your request. Please try again.',
		unexpected_error_short: 'An unexpected error occurred.',
		unexpected_error_retry:
			'An unexpected error occurred. Please try again.',
	},
	landing: {
		mortgage_rates: 'Mortgage rates',
		how_to_apply: 'How would you like to apply?',
		apply_now: 'Apply Now',
		what_would_you_like_today: 'What would you like to do today?',
		check_out_todays_rates: "Check out today's rates",
		get_your_rate: 'Get your rate',
		customer_testimonials: 'Customer Testimonials',
		visit_linkedin: 'Visit us on LinkedIn',
		visit_facebook: 'Visit us on Facebook test',
		visit_instagram: 'Visit us on Instagram',
		visit_x: 'Visit us on X',
		visit_youtube: 'Visit us on YouTube',
	},
	legal: {
		website: 'Website',
		contact_us: 'Contact us',
		privacy_policy: 'Privacy Policy',
		terms: 'Terms of Use',
		license_info: 'License Information',
	},
	create_account: {
		title: 'Create Account',
		create_account: 'Create an account',
		please_wait: 'Please wait while we fetch your invitation',
		invite_expired: 'The invite has expired',
		request_new: 'Please request a new invite from your Loan Officer',
		first_name: 'First name',
		last_name: 'Last name',
		sign_up: 'Sign up',
	},
	mortgage: {
		fixed_15_years: 'Fixed 15 Years',
		conventional_30_years: 'Conventional 30 Years',
		todays_rates: "Today's rates",
		fixed: 'Fixed',
		conventional: 'Conventional',
	},
	alerts: {
		save_success: 'The {name} successfully updated',
		delete_success: 'The {name} successfully deleted',
		sent_to_los: 'The loan draft was successfully sent to LOS',
		pop_up_blocker_enabled:
			'Pop-up Blocker is enabled! Please add this site to your exception list and try again.',
		invites_success: 'Your invite(s) were sent successfully.',
		invites_failed: 'There was a problem sending your invite(s).',
		invite_sent_to: 'Invite sent to:',
		invite_success_to: 'Invite successfully sent to {emailAddress}',
		invite_failed_to:
			'There was a problem sending invite to {emailAddress}',
		revoke_loan_success: 'Successfully revoked access for {name}.',
		revoke_loan_failed:
			'Failed to revoke access for {name}. Please try again.',
		role_update_success: 'Successfully updated role for {name}.',
		role_update_failed:
			'Failed to update role for {name}. Please try again.',
		share_loan_success: 'Successfully updated loan access.',
		share_loan_failed:
			'Failed to update loan access. Please try again.',
		pipeline_loading_error:
			'There was a problem loading the applications',
		user_groups_create_success: 'User group created successfully',
		user_groups_update_success: 'User group updated successfully',
		user_groups_create_failed: 'Failed to create user group',
		user_groups_update_failed: 'Failed to update user group',
		user_groups_delete_success: 'User group deleted successfully',
		user_groups_delete_failed: 'Failed to delete user group',
		user_groups_name_already_exists:
			'A group with this name already exists',
		user_groups_access_update_success:
			'User group access updated successfully',
		user_groups_access_update_failed:
			'Failed to update user group access',
	},
	dropzone: {
		instructions: "Drag 'n' drop files here or click to select files",
		edit_file_name: 'Edit File Name',
		file_too_large: 'File is larger than {size} bytes',
		up_to_files: 'Up to {size} files',
		up_to: 'Up to',
	},
	task_verification: {
		default_button_title: 'Verify Me',
		manual_upload_button_title: 'Manual Upload',
		loan_locked_notice:
			'Your loan is currently in use. Once it is updated, your verification messages will be sent.',
		success:
			'Success! Please check your SMS or email inbox for next steps.',
		task_verification_copy_by_type: {
			VerificationOfAssets: {
				heading: 'Verify Your Financial Assets',
				body: `Click "Start Verification" to receive a text message and email that will guide you through verifying your assets. These messages will help you sign into your online banking account to select the accounts you'd like to share. Alternatively, you can upload your bank statements manually.`,
				button_title: `Start Verification`,
			},
			VerificationOfIncome: {
				heading: 'Verify Your Income',
				body: `Click "Start Verification" to receive a text message and email that will guide you through verifying your INCOME. These messages will help you sign into your online banking account to select the accounts you'd like to share. Alternatively, you can upload your bank statements manually.`,
				button_title: `Start Verification`,
			},
			VerificationOfEmployment: {
				heading: 'Verify Your Employment',
				body: `Click "Start Verification" to receive a text message and email that will guide you through verifying your EMPLOYMENT. These messages will help you sign into your online banking account to select the accounts you'd like to share. Alternatively, you can upload your bank statements manually.`,
				button_title: `Start Verification`,
			},
			VerificationOfIncomeAndEmployment: {
				heading: 'Verify Your Income & Employment',
				body: `Click "Start Verification" to receive a text message and email that will guide you through verifying your INCOME & EMPLOYMENT. These messages will help you sign into your online banking account to select the accounts you'd like to share. Alternatively, you can upload your bank statements manually.`,
				button_title: `Start Verification`,
			},
		},
	},
	task_form: {
		weight_helper_text:
			'Weight is used for sorting. The lower the number, the higher it will display in the list.',
		weight_label: 'Weight',
	},
	templates: {
		delete_version_prompt:
			'Are you sure you want to delete this version?',
		delete_version: 'Delete Version',
		delete_selected_version: 'Delete selected version',
		save_as_new_version: 'Save as new version',
		template_created: 'Template successfully created',
		add_template_title: `Add {name} Template`,
	},
	remove_record: {
		permanent_deletion: 'Permanent Deletion',
		permanent_delete:
			'Permanently Delete "{value}" & All Associated Data?',
		delete: 'Delete',
		cancel: 'Cancel',
		confirm_delete: 'Confirm Delete',
		confirm_permanent_deletion: 'Confirm Permanent Deletion',
		confirm_reactivate: 'Confirm Reactivation',
		remove: 'Remove',
		restore: 'Restore',
		confirm_deletion: 'Yes, Remove It',
		confirm_restore: 'Yes, Restore It',
	},
	warnings: {
		no_revert_possible: 'WARNING: THIS CAN NOT BE UNDONE',
		accept_no_revert_possible:
			'By checking this box I confirm that I understand that this action can not be undone.',
		change_email:
			'Changing your email address may disassociate existing loan invites and assignments',
		change_email_denied:
			'You do not have permission to change your email address',
	},
	modals: {
		confirm_send_to_los:
			'Are you sure you want to send this to the LOS?',
	},
	drafts: {
		send_to_los: 'Send to LOS',
	},
	invites: {
		send_invite: 'Send Invite',
		multi_invite: 'Multi-invite',
		pending_invites: 'Pending Invites',
		econsent_title: 'Creating User Accounts',
		econsent_disclaimer:
			"Users will be prompted to e-Consent as soon as they log into their POS Account. If they don't have an account just invite them by clicking this button:",
		invite_reminder: 'Invite Reminder',
	},
	sso: {
		sso_integrations: 'SSO Integrations',
		download_cc_metadata_file: 'Download Consumer Connect Metadata',
		download_bpos_metadata_file: 'Download POS Metadata',
		regenerate_cc_metadata_file:
			'Regenerate Consumer Connect Metadata',
		regenerate_bpos_metadata_file: 'Regenerate POS Metadata',
	},
	form_validations: {
		empty_when_dont_send_selected:
			"Should be empty when 'Don't send' is selected",
		at_least_one_borrower_selected:
			'At least one borrower must be selected',
		select_document_template: 'Please select a Document Template',
		notification_option_required: 'Notification option is required',
	},
	mobile_settings: {
		heading: 'Mobile Settings',
		has_mobile_switch: 'Enable Mobile App',
		mobile_app_universal_url: 'Mobile App Universal URL *',
		mobile_app_enter_url: 'Enter url',
		mobile_app_universal_url_desc:
			'Dynamic link to your mobile app, it will be scannable by the QR Code.',
		mobile_app_app_store_url: 'App Store URL *',
		mobile_app_google_play_url: 'Google Play URL *',
		mobile_app_url_required: 'Mobile App URL is required',
		mobile_app_url_invalid: 'Must be a valid URL',
		mobile_settings_success: 'Mobile settings updated successfully',
		mobile_settings_error: 'Error updating mobile settings',
		what_is_universal_url: 'What is a Universal URL?',
		download_our_mobile_app: 'Download Our Mobile App',
		download_it_on_google_play: 'Download it on Google Play',
		download_it_on_app_store: 'Download it on the App Store',
		mobile_settings_updated_successfully:
			'Mobile settings updated successfully',
		error_updating_mobile_settings: 'Error updating mobile settings',
	},
	generate_loan_document: {
		generate_button_text: 'Generate Document',
		notification_option: 'Notification Option',
		select_borrowers: 'Select Borrowers',
		dont_send: "Don't send",
		send_to_all_borrowers: 'Send to all borrowers',
		send_to_specific_borrowers: 'Send to specific borrowers',
		send_to_borrower: 'Send to {name}',
	},
	add_coborrower_form: {
		modal_heading: 'Add Additional Borrower',
		add_a_coborrower: 'Add a Co-Borrower',
		method_heading: 'Please choose your preferred method of entry...',
		invite_heading: "Enter the Co-Borrower's contact information...,",
		send_invitation: 'Send Invitation',
		provide_information: "I'll Provide the Information",
		relationship:
			'Are you and {name} married or joined in a civil union?',
		married_civil_union: 'Married/Civil Union',
		disclaimer: {
			heading:
				'Please review the information below. If satisfied, please click the button below to send the invitation.',
			body: 'By clicking the "Send Invitation" button below, you acknowledge that an email and text message will be sent to the recipient. Text and data rates may apply.',
		},
		max_borrowers_reached:
			'You have reached the maximum number of borrowers.',
		loan_locked_notice:
			'Cannot add a Co-Borrower to a Locked Loan File',
	},
	user_profile: {
		email_change: 'Enable email change',
	},
	workflow: {
		connected_sites: 'Connected Sites',
		available_sites: 'Available Sites',
	},
	entity_type: {
		account: 'Account',
		branch: 'Branch',
		user: 'User',
		loan_officer: 'Loan Officer',
		partner: 'Realtor',
		corporate: 'Brand',
	},
	loan_calculator: {
		submit: 'Update Loan & Calculate Payment',
	},
	site_configuration: {
		loading: 'Loading configuration, please wait',
		fetch_error: 'There was an error fetching the site configuration',
		update_success: 'Site configuration successfully updated',
		update_error:
			'There was an error updating the site configuration',
	},
	loan_settings: {
		heading: 'Loan Settings',
		exclude_from_auto_task_reminders:
			'Exclude from Auto Task Reminders',
		missing_loan_id: 'Loan ID is required to update loan settings',
		update_success: 'Loan settings updated',
	},
	auto_task_reminders: {
		title: 'Auto Task Reminders',
		days: 'Days',
		before: 'Before',
		after: 'After',
		due_date: 'Due Date',
		add_reminder: 'Add Reminder',
		on_due_date: 'On Due Date',
		submit_reminders: 'Set Reminders',
		open_settings: 'Open Reminder Settings',
		reminders_set: '{count} Reminders Set',
		validation: {
			days: {
				min: 'Days must be a positive number',
				required: 'Days are required',
			},
			sequence: {
				oneOf: 'Sequence must be either "before" or "after"',
				required: 'Sequence is required',
			},
			duplicate: 'Reminder already exists',
		},
	},
	mortgage_calculators: {
		mortgage_calculators: 'Mortgage Calculators',
		monthly_payment_calculator: 'Monthly Payment Calculator',
		affordability_calculator: 'Affordability Calculator',
		refinance_calculator: 'Refinance Calculator',
		loan_comparison_calculator: 'Loan Comparison Calculator',
		loan_amount: 'Loan Amount',
		loan_term: 'Loan Term',
		home_value: 'Home Value',
		interest_rate: 'Interest Rate',
		pmi: 'PMI',
		pmi_help_text:
			'Private Mortgage Insurance protects the lender if you default, and is usually required when your down payment is under 20%.',
		annual_taxes: 'Annual Taxes',
		annual_insurance: 'Annual insurance',
		num_years: '{num} years',
		calculate: 'Calculate',
		disclaimer:
			'There is no express or implied warranty for the accuracy of this information. The information is provided for illustrative purposes only. This is not a credit decision or a commitment to lend. Please contact a loan consultant or financial advisor for more information.',
		monthly_payment: 'Monthly Payment',
		principal_and_interest: 'Principal & Interest',
		insurance: 'Insurance',
		taxes: 'Taxes',
		ltv: 'LTV',
		payment_period: 'Payment Period',
		balance: 'Balance',
		periods: 'Periods (months)',
		months_with_pmi: 'Months with PMI',
		periodic_interest: 'Periodic Interest',
		periodic_payment: 'Periodic Payment',
		total_interest: 'Total Interest',
		total_payment: 'Total Payment',
		date: 'Date',
		interest: 'Interest',
		principal: 'Principal',
		amortization: 'Amortization',
		total_monthly_income: 'Total Monthly Income',
		total_monthly_expenses: 'Total Monthly Expenses',
		total_monthly_payment: 'Total Monthly Payment',
		front_ratio: 'Front Ratio',
		front_ratio_help_text:
			'The percentage of your gross monthly income that goes toward housing costs, such as mortgage payments, property taxes, insurance, and HOA fees.',
		back_ratio: 'Back Ratio',
		back_ratio_help_text:
			'The percentage of your gross monthly income that goes toward all monthly debts combined, including housing costs, credit cards, auto loans, student loans, and other obligations.',
		down_payment: 'Down Payment',
		marginal_tax_rate: 'Marginal Tax Rate',
		marginal_tax_rate_help_text:
			'Your highest tax bracket, used to estimate mortgage interest tax savings.',
		state_tax_rate: 'State Tax Rate',
		current_loan: 'Current Loan',
		refinance_loan: 'Refinance Loan',
		current_loan_amortization: 'Current Loan Amortization',
		refinance_loan_amortization: 'Refinance Loan Amortization',
		original_loan_amount: 'Original Loan Amount',
		origination_fees: 'Origination Fees',
		months_paid: 'Months Paid',
		points: 'Points',
		closing_costs: 'Closing Costs',
		years_before_sale: 'Years Before Sale',
		total_benefit: 'Total Benefit',
		total_savings: 'Total Savings',
		total_losses: 'Total Losses',
		tax_savings: 'Tax Savings',
		tax_losses: 'Tax Losses',
		monthly_payment_savings: 'Monthly Payment Savings',
		monthly_payment_losses: 'Monthly Payment Losses',
		current_monthly_payment: 'Current Monthly Payment',
		refinance_monthly_payment: 'Refinance Monthly Payment',
		loan_num: 'Loan {num}',
		loan_num_amortization: 'Loan {num} Amortization',
		validation: {
			lt_income: 'Must be less than Total Monthly Income',
			gt_loan_amount: 'Must be greater than Loan Amount',
			percentage: 'Must be a percentage (0-100)',
		},
	},
	share_loan: {
		title: 'Share Loan',
		incomplete_title: 'Share Incomplete Loan',
		revoke_access_loan: 'Revoke Access',
		edit_access_loan: 'Edit Access',
		confirm_access_revocation: 'Confirm Access Revocation',
		undone_message:
			'This action cannot be undone. The user will lose access to this loan immediately.',
		revocation_title_question:
			'Are you sure you want to revoke access for the following user?',
		description:
			'Select a user and assign them a role to share this loan with them.',
		select_user: 'Select User',
		search_and_select_user: 'Search and select a user',
		add_user: 'Add User',
		name: 'Name',
		assigned_role: 'Assigned Role',
		remove_user: 'Remove User',
		restore_user: 'Restore User',
		no_users_found: 'No users found',
		start_typing_to_search: 'Start typing to search for users',
		validation: {
			please_select_user: 'Please select a user',
			please_select_branch: 'Please select a branch',
			please_select_role: 'Please select a role',
			user_already_added: 'This user has already been added',
			branch_already_added: 'This branch has already been added',
			add_at_least_one_user: 'Please add at least one user',
			cannot_select_self: 'You cannot select yourself',
		},
		empty_state: {
			title: 'No users added yet',
			description:
				'Start by searching and selecting a user, then assign them a role.',
			hint: 'Use the search field above to find users to share this loan with.',
		},
	},
	user_groups: {
		title: 'User Groups',
		add_group: 'Add Group',
		title_modal_group_members: 'Group Members',
		title_modal_group_access: 'Group Access',
		access_target: 'Access Target',
		fields: {
			group_name: 'Group Name',
			description: 'Description',
		},
		table: {
			columns: {
				group_name: 'Group Name',
				description: 'Description',
				total_members: 'Total Members',
				total_access: 'Total Access',
			},
			actions: {
				edit_members: 'Edit Members',
				edit_access: 'Edit Access',
				delete_group: 'Delete Group',
			},
		},
		empty_state: {
			no_access_items: 'No access items added yet',
			add_users_branches:
				'Add users or branches for group members to access',
			use_form_above:
				'Use the form above to add users or branches this group can access',
		},
		delete_modal: {
			title: 'Confirm Group Deletion',
			question: 'Are you sure you want to delete this group?',
			warning:
				'This action cannot be undone. The group and all its access permissions will be permanently deleted.',
			description_label: 'Description:',
			no_description: 'No description',
			cancel_button: 'Cancel',
			delete_button: 'Delete Group',
		},
	},
	pipeline: {
		my_applications: 'My Applications',
		loan_applications: 'Loan Applications',
		loan_pipeline_tab: 'Loan Pipeline',
		incomplete_loans_tab: 'Incomplete loans',
		tabs_aria_label:
			'Navigation tabs for loan pipeline and incomplete applications',
		expanded_row: {
			borrower: 'Borrower',
			co_borrower: 'CoBorrower',
		},
		columns: {
			loan_number: 'Loan Number',
			loan_amount: 'Loan Amount',
			address: 'Address',
			application_date: 'Application Date',
		},
		not_yet_assigned: 'Not yet assigned',
		view_application: 'View Application',
		impersonate: 'Impersonate',
	},
	loan_documents: {
		heading: 'Loan Documents',
		download_modal: {
			heading: 'Download Documents',
			download_all: 'Download All',
		},
		locked_upload_notice:
			'Your uploads are processing and some actions may not be available. Please check back later for status changes.',
	},
	media_library: {
		rows_per_page_label: 'Items per page',
		file_processing:
			'This file is still processing. Please check back later to view.',
	},
	upload_media: {
		modal: {
			heading: 'Upload Media',
		},
		form: {
			accepted_file_types: 'Accepted file types:',
			required: 'At least 1 file is required',
			is_valid_type: 'Not an accepted file type',
		},
		alerts: {
			upload_success: '{name} uploaded successfully',
		},
	},
	send_documents_modal: {
		heading: 'Send Documents',
		attachments_label: 'Attachments',
		alerts: {
			send_success: 'Documents sent successfully',
			send_error: 'There was an error sending the documents',
		},
	},
	send_documents_form: {
		loan_users_label: 'Loan Users',
		external_users_label: 'External Users',
		add_email_address: 'Add External Email',
		at_least_one_email_address:
			'At least one email address is required',
	},
}
